import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, MenuItem, Select, Stack } from '@mui/material';
import { useState } from 'react';
import { WidgetInstance } from '../types';
import { GiftsByPeriodConfig } from './giftsByPeriodWidget';

type Props = {
  open: boolean;
  instance: WidgetInstance | null;
  onClose: () => void;
  onSave: (instance: WidgetInstance) => void;
};

export const GiftsByPeriodConfigDialog = ({ open, instance, onClose, onSave }: Props) => {
  const initial = (instance?.config as GiftsByPeriodConfig | undefined) ?? { period: 'thisMonth' };
  const [period, setPeriod] = useState<GiftsByPeriodConfig['period']>(initial.period);

  if (!instance) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>Konfigurera: Gåvor för period</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <FormControl fullWidth size='small'>
            <FormLabel sx={{ fontSize: 12, mb: 0.5 }}>Period</FormLabel>
            <Select value={period} onChange={(e) => setPeriod(e.target.value as GiftsByPeriodConfig['period'])}>
              <MenuItem value='thisMonth'>Denna månad</MenuItem>
              <MenuItem value='lastMonth'>Förra månaden</MenuItem>
              <MenuItem value='thisYear'>I år</MenuItem>
              <MenuItem value='lastYear'>Förra året</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Avbryt</Button>
        <Button
          variant='contained'
          onClick={() => {
            onSave({ ...instance, config: { period } as GiftsByPeriodConfig });
            onClose();
          }}
        >
          Spara
        </Button>
      </DialogActions>
    </Dialog>
  );
};
